module.exports = __webpack_public_path__ + "static/media/3.05f3f0ed.jpg";